import axios from "../../axios/axios";
import {
  COMPANY_LOAD_FAIL,
  COMPANY_LOAD_REQUEST,
  COMPANY_LOAD_RESET,
  COMPANY_LOAD_SINGLE_FAIL,
  COMPANY_LOAD_SINGLE_REQUEST,
  COMPANY_LOAD_SINGLE_RESET,
  COMPANY_LOAD_SINGLE_SUCCESS,
  COMPANY_LOAD_SUCCESS,
  COMPANY_CREATE_SUCCESS,
  COMPANY_CREATE_FAIL,
  COMPANY_CREATE_LOAD,
} from "../constants/companyConstant";
import { toast } from "react-toastify";

export const createCompanyAction = (company, navigate) => async (dispatch) => {
  dispatch({ type: COMPANY_CREATE_LOAD });
  try {
    const { data } = await axios.post(`/api/company`, company);
    dispatch({
      type: COMPANY_CREATE_SUCCESS,
      payload: data,
    });
    navigate("/");
  } catch (error) {
    console.log(error.response);
    dispatch({
      type: COMPANY_CREATE_FAIL,
      payload: error.response.data.message,
    });
    toast.error(error.response.data.message);
  }
};

export const companyLoadAction =
  (pageNumber, keyword = "", cat = "", location = "") =>
  async (dispatch) => {
    dispatch({ type: COMPANY_LOAD_REQUEST });
    try {
      const { data } = await axios.get(`/api/company`);
      console.log(data);
      dispatch({
        type: COMPANY_LOAD_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: COMPANY_LOAD_FAIL,
        payload: error.response.data.error,
      });
    }
  };
